import { useMovableInkCampaignContext } from 'modules/movableInk/contexts/MovableInkCampaignContext';
import { useMovableInkIntegrationContext } from 'modules/movableInk/contexts/MovableInkIntegrationContext';
import { usePanelContext } from 'modules/movableInk/contexts/Panel';
import { useCallback, useMemo } from 'react';
import { BaseOption } from 'ui/selectv2/types';

export const useIntegrationOptionsState = () => {
  const {
    selectedIntegration,
    integrations,
    isFetchingIntegrations,
    setSelectedIntegration,
    setCurrentCompanyId,
  } = useMovableInkIntegrationContext();
  const { setCampaignId } = useMovableInkCampaignContext();
  const { setPanelSearch } = usePanelContext();

  const options = useMemo(() => {
    return integrations.map(({ name, tokenId }) => ({
      label: name,
      value: tokenId.toString(),
    }));
  }, [integrations]);

  const onSelect = useCallback(
    ([{ value }]: BaseOption<string>[]) => {
      const intId = parseInt(value, 10);
      const integration = integrations.find(({ tokenId }) => intId === tokenId);
      if (integration) {
        setSelectedIntegration(integration);
        setCampaignId();
        setCurrentCompanyId();
        setPanelSearch('');
      }
    },
    [integrations, setSelectedIntegration, setCampaignId, setCurrentCompanyId, setPanelSearch],
  );

  const selectedOption = useMemo(() => {
    if (!selectedIntegration) return [];
    const stringId = selectedIntegration.tokenId.toString();
    return [options.find(({ value }) => value === stringId)];
  }, [options, selectedIntegration]);

  const isDisabled = useMemo(
    () => !isFetchingIntegrations && integrations.length === 0,
    [isFetchingIntegrations, integrations],
  );

  return {
    selectedOption,
    isDisabled,
    onSelect,
    options,
    isLoading: isFetchingIntegrations,
  };
};
